import {secureDownload, secureFetch} from './authService';
import {API_BASE_URL, API_UPLOAD_URL, PAGINATION_DEFAULT_LIMIT} from './constants';

export function getCompaniesStatsByDate(dates) {
	let url = API_BASE_URL + '/statistic/reports/byCompanies?';
	if (dates.dateTo) {
		url = url + `&dateTo=${dates.dateTo}`
	}
	if (dates.dateFrom) {
		url = url + `&dateFrom=${dates.dateFrom}`
	}
	return secureFetch(url, {
		method: 'GET',
	});
}


export function getCompanyStatsByDate(companyId, dates) {
	let url = API_BASE_URL + '/statistic/reports/company?';
	if (companyId) {
		url = url + `&companyId=${companyId}`
	}
	if (dates.dateTo) {
		url = url + `&dateTo=${dates.dateTo}`
	}
	if (dates.dateFrom) {
		url = url + `&dateFrom=${dates.dateFrom}`
	}
	return secureFetch(url, {
		method: 'GET',
	});
}

export function getSalesPointStatsByDate(pointId, dates) {
	let url = API_BASE_URL + `/statistic/reports/salesPoint/${pointId}?`;
	if (dates.dateTo) {
		url = url + `&dateTo=${dates.dateTo}`
	}
	if (dates.dateFrom) {
		url = url + `&dateFrom=${dates.dateFrom}`
	}
	return secureFetch(url, {
		method: 'GET',
	});
}

export function getAppsStatsByDateAndStore(query) {
	let url = API_BASE_URL + `/statistic/reports/apps?`;

	if (query) {
		const {page = 0, filters, limit = PAGINATION_DEFAULT_LIMIT, sorting} = query;

		if (limit) {
			url = url + `&limit=${limit}`;
		}

		if (page || page === 0) {
			url = url + `&page=${page}`;
		}

		if (filters && filters.length) {
			filters.forEach(filter => {
				if (filter.value) {
					url = url + `&${filter.name}=${filter.value}`;
				}
			});
		}
	}
	return secureFetch(url, {
		method: 'GET',
	});
}

export function 	getTotalStatsByDate(query) {
	let url = API_BASE_URL + '/statistic/reports/company/total?';
	if (query) {
		const {
			page = 0,
			filters,
			limit = PAGINATION_DEFAULT_LIMIT,
			companyId,
			userId,
			sorting,
			dateTo,
			dateFrom,
		} = query;

		if (limit) {
			url = url + `&limit=${limit}`;
		}

		if (page || page === 0) {
			url = url + `&page=${page}`;
		}

		if (companyId) {
			url = url + `&companyId=${companyId}`;
		}

		if (userId) {
			url = url + `&userId=${userId}`;
		}

		if (dateTo) {
			url = url + `&dateTo=${dateTo}`;
		}
		if (dateFrom) {
			url = url + `&dateFrom=${dateFrom}`;
		}

		if (filters && filters.length) {
			filters.forEach(filter => {
				if (filter.value) {
					url = url + `&${filter.name}=${filter.value}`;
				}
			});
		}

		if (sorting) {
			url = url + `&sortField=${sorting.id}&sort=${sorting.desc ? 'ASC' : 'DESC'}`;
		}
	}
	return secureFetch(url, {
		method: 'GET',
	});
}

export function downloadCompanyStat(query) {
	const {dateTo, dateFrom, companyId} = query;
	let url = API_UPLOAD_URL + '/statistic/reports/company/csv?';
	if (dateTo) {
		url = url + `&dateTo=${dateTo}`
	}
	if (dateFrom) {
		url = url + `&dateFrom=${dateFrom}`
	}
	if (companyId) {
		url = url + `&companyId=${companyId}`
	}
	return secureDownload(url, {
		method: 'GET',
	});
}

export function downloadCompaniesStat(query) {
	const {dateTo, dateFrom, companyId} = query;
	let url = API_UPLOAD_URL + '/statistic/reports/byCompanies/csv?';
	if (dateTo) {
		url = url + `&dateTo=${dateTo}`
	}
	if (dateFrom) {
		url = url + `&dateFrom=${dateFrom}`
	}
	if (companyId) {
		url = url + `&companyId=${companyId}`
	}
	return secureDownload(url, {
		method: 'GET',
	});
}

export function downloadTotalStat(query) {
	const {dateTo, dateFrom, companyId, userId} = query;
	let url = API_UPLOAD_URL + '/statistic/reports/company/total/csv?';
	if (dateTo) {
		url = url + `&dateTo=${dateTo}`
	}
	if (dateFrom) {
		url = url + `&dateFrom=${dateFrom}`
	}
	if (companyId) {
		url = url + `&companyId=${companyId}`
	}
	if (userId) {
		url = url + `&userId=${userId}`
	}
	return secureDownload(url, {
		method: 'GET',
	});
}

export function updateCommentsByTotalReportCsv(data) {
	return secureFetch(API_UPLOAD_URL + '/statistic/reports/comments/total/csv', {
		method: 'PUT',
		body: data
	}, {});
}

export function updateCommentsByOperatorTotalReportCsv(data) {
	return secureFetch(API_UPLOAD_URL + '/statistic/operatorReports/comments/total/csv', {
		method: 'PUT',
		body: data
	}, {});
}


// WEBPACK FOOTER //
// ./src/helpers/statService.js